/**
 * Returns the url for a media asset, appending the backend server url if the
 * url returned by the server starts with a slash. Supports connecting to
 * a local backend server that doesn't have Google Cloud storages connected.
 */
export default async (asset: MediaAsset) => {
  if (asset === null || asset === undefined) {
    return '';
  }
  // if (asset.asset_file[0] === '/') {
  const { getMediaAssetBlob } = useApi();
  return URL.createObjectURL(await getMediaAssetBlob(asset.id));
  // }
  // return asset.asset_file;
};
